/* eslint-disable padding-line-between-statements */
/* eslint-disable no-secrets/no-secrets */
import { BreakpointTrackerContext } from '@jutro/layout';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import _, { isUndefined } from 'lodash';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { TranslatorContext } from '@jutro/locale';
import { Loader } from '@jutro/components';
import TFPAQuoteUtilsService from '../../../../../capabilities/tfpa-capability-quoteandbind-residential/services/TFPAQuoteUtilsService.js';
import metadata from './LocationDetails.metadata.json5';
import styles from './LocationDetails.module.scss'
import messages from './LocationDetails.messages.js'

function LocationDetails(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { authHeader } = useAuthentication();
    const translator = useContext(TranslatorContext);
    const [ppcLoading, setPpcLoading] = useState(false);
    const { yourHomeVM, submissionVM, updateSubmissionVM,enableApplyCodes,resetAllCodes, 
        showMessage,setShowMessage,showErrors, findInvalidComponent, onValidate } = props;
    const LOCATION_COMPONENT = 'LocationDetails';
    const [eastHighway, setEastHighway] = useState(false);
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(LOCATION_COMPONENT);
    // Fix for required message
    const eastOfHighway146 = _.get(yourHomeVM, 'primaryAddress.eastOfHighway146_Ext.value');

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, LOCATION_COMPONENT);
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        findInvalidComponent(isComponentValid, LOCATION_COMPONENT);
    }, [findInvalidComponent, isComponentValid])

    useEffect(() => {
        // DE16172
        const isEastHighway = _.get(yourHomeVM, 'primaryAddress.eastOfHighway146_Ext.value');
        const isEastHighwayRequired = _.get(yourHomeVM, 'primaryAddress.eastOfHighway146_Ext.aspects.required');
        const isTerritoryCode1 = _.get(yourHomeVM, 'primaryAddress.territoryCode_Ext.value.code');
        if ((isEastHighway !== undefined || isEastHighwayRequired === true) && isTerritoryCode1 === '1') {
            setEastHighway(true);
        }
    }, [])


    const navigateToGoogleMaps = useCallback(() => {
        const url = 'https://maps.google.com/';

        // eslint-disable-next-line security/detect-non-literal-fs-filename
        window.open(url, '_blank');
    }, []);

    const onApplyPublicProtectionClass = async () => {
        if (enableApplyCodes) {

            setPpcLoading(true);
            resetAllCodes()

            _.set(submissionVM, 'lobData.homeowners_tfpa.coverables_Ext.construction', undefined);

            TFPAQuoteUtilsService.applyCodes_TFPA(submissionVM.value, authHeader).then((resp) => {
                const address = resp.primaryAddress || {};

                _.set(yourHomeVM, 'dwellingProtectionClassCode_Ext.value', resp.dwellingProtectionClassCode_Ext);
                _.set(yourHomeVM, 'primaryAddress.territoryCode_Ext.value.code', address.territoryCode_Ext.code);
                _.set(yourHomeVM, 'primaryAddress.county.value', address.county);
                // _.set(yourHomeVM, 'primaryAddress.eastOfHighway146_Ext.value', address.eastOfHighway146_Ext);
                if (address.territoryCode_Ext.code === '1' && address.eastOfHighway146_Ext === true) {
                    setEastHighway(true);
                } else {
                    setEastHighway(false);
                }
                updateSubmissionVM(yourHomeVM);
                setPpcLoading(false);
                setShowMessage(false);
            },
                (err) => {
                    console.error(`Error: ${err}`);
                    resetAllCodes()
                    setShowMessage(false);
                    setPpcLoading(false);
                }
            );

        }
    };
     
    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            readOnly : true
        },
        googleMaps: {
            visible: eastHighway,
            disabled: true
        },
        eastHighway: {
            visible: eastHighway,
            validationMessages: !_.isUndefined(eastOfHighway146) ? [] : [translator(messages.requiredMessage)]
        },
        county: {
            disabled: !enableApplyCodes() // DE16175
        },
        applyPublicProtectionClass: {
            disabled: !enableApplyCodes()
        },
        territoryCodeNotification: {
            visible: showMessage
        }
    }

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {},
        resolveCallbackMap: {
            googleMapsLink: navigateToGoogleMaps,
            onApplyPublicProtectionClass
        },
    };

    return (
        <Loader loaded={!ppcLoading}>
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={yourHomeVM}
            overrideProps={overrideProps}
            showErrors={showErrors}
            // onModelChange={updateWizardData}
            onValidationChange={setComponentValidation}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
        </Loader>
    );
}

LocationDetails.propTypes = wizardProps;
export default LocationDetails;
